export default __webpack_public_path__ + "static/O0022-ce912010518c8c959c7512d2193ccda5.png";